module.exports = __webpack_public_path__ + "img/charts.f2a236f3.png";